import dayjs from 'dayjs';
import { noCurrency } from 'helpers/utils';
const utc = require('dayjs/plugin/utc');
const timezone = require('dayjs/plugin/timezone');

// Agregar los complementos necesarios para Day.js
dayjs.extend(utc);
dayjs.extend(timezone);

// Establecer la zona horaria a "America/Bogota"
dayjs.tz.setDefault('America/Bogota');

export const create = data => {
 const { items, detail, type, amount, start, end, receivers, commissions, emitters, financing, ...params } = data;
 return {
  type,
  detail,
  items,
  amount: noCurrency(amount),
  start: dayjs(start).unix(),
  end: dayjs(end).unix(),
  receivers,
  emitters,
  financing,
  commissions: { person: noCurrency(commissions.person) },
  params
 };
}; // frequency
